import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4_sass@1.97.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4_sass@1.97.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/contact-form/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlockErrorBoundary"] */ "/vercel/path0/src/components/blocks/content-renderer/components/block-error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQ"] */ "/vercel/path0/src/components/blocks/faq/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageCarousel"] */ "/vercel/path0/src/components/blocks/image-carousel/image-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/src/components/blocks/testimonials/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoGrid"] */ "/vercel/path0/src/components/blocks/video-grid/video-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/vercel/path0/src/components/global/live-preview-listener/live-preview-listener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselContent","CarouselItem","CarouselNext","CarouselPrevious"] */ "/vercel/path0/src/components/ui/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FileUpload"] */ "/vercel/path0/src/components/ui/file-upload/file-upload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Marquee","MarqueeFade","MarqueeContent","MarqueeItem"] */ "/vercel/path0/src/components/ui/shadcn-io/marquee/index.tsx");
